export class GetPostId {
  public execute(): string | null {
    return new URLSearchParams(window.location.search).get('postId')
  }
}
